import React, { useEffect, useState } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { useField, useFormikContext } from 'formik';
import FormikRadioField from 'forms/fields/RadioField/FormikRadioField';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-hot-toast';

const { el } = bem( 'delivery-fields', 'cdek-delivery' );

const CDEK = observer(({ form, items, setDeliveryPrice, showWidget, setShowWidget, selected, cdekLoadStatus } ) => {
    const values = form.values;
    const delivery = form.values.delivery;
    const cityCode = form.values.cityCode;

    const [ widget, setWidget ] = useState(null);

    const { setFieldValue } = useFormikContext();

    const [_field, meta] = useField({ name: 'cdekDeliveryType', type: 'text' });

    useEffect(() => {
        if (cdekLoadStatus === 'pending' || cdekLoadStatus === 'failed') {
            return;
        }
        if (!window.CDEKWidget) {
            console.log('no ISDEKWidjet was in window object');
            return;
        }
        if (delivery === 'cdek') {
            const initWidget = new window.CDEKWidget( {
                root: 'forpvz',
                popup: false,
                apiKey: '5a4ac072-e795-4077-9413-b5e01373d78d',
                servicePath: '/cdek/service.php',
                defaultLocation: 'Москва',
                from: 'Москва',
                hideFilters: {
                    is_dressing_room: false
                },
                detailAddress: true,
                goods: items,
                tariffs: {
                    door: [137, 233, 8],
                    office: [136, 234],
                    pickup: [136, 234]
                },
                onReady: () => {
                    console.log( 'cdek ready' )
                },
                onChoose: (mode, tariff, address) => {
                    console.log( 'cdek choose' )
                    if (!['door', 'office'].includes(mode)) {
                        console.error('wrong delivery type: ', mode);
                        toast.error('Ошибка при выборе способа доставки. Пожалуйста, обратитесь к администратору')
                    }
                    const { tariff_code, delivery_sum, tariff_name } = tariff;
                    console.log(mode, tariff, address);
                    if (!tariff_code || !delivery_sum) {
                        toast.error('Ошибка при вычислении суммы доставки')
                        setFieldValue('tarif', null);
                        setFieldValue('price', null);
                        setFieldValue('pvz', null);
                        setFieldValue('city', null);
                        setFieldValue('cityCode', null);
                        setFieldValue('address', null);
                        setFieldValue('cdekDeliveryType', null);
                        setShowWidget(false)
                        return
                    }
                    setFieldValue('tarif', tariff_code);
                    setFieldValue('price', delivery_sum.toString());
                    if (mode === 'office') {
                        setFieldValue('pvz', address?.code);
                        setFieldValue('city', address?.city);
                        setFieldValue('address', address?.address);
                        setFieldValue('cityCode', address?.city_code);
                        setFieldValue('cdekDeliveryType', 'pvz');
                    }
                    if (mode === 'door') {
                        setFieldValue('pvz', null);
                        setFieldValue('city', address?.city);
                        setFieldValue('address', address?.formatted);
                        setFieldValue('cdekDeliveryType', 'courier');
                    }
                    setDeliveryPrice(delivery_sum);
                    setShowWidget(false)
                },
                onCalculate: (mode, tariff, address) => {
                    console.log( 'cdek calculate' );
                    console.log(mode, tariff, address);
                    const { delivery_sum } = tariff;
                    delivery_sum && setDeliveryPrice(delivery_sum);
                }
            } )
            setWidget(initWidget);
        } else {
            setWidget(null);
            setFieldValue('tarif', null);
            setFieldValue('price', null);
            setFieldValue('pvz', null);
            setFieldValue('city', '');
            setFieldValue('cityCode', null)
            setFieldValue('address', '');
            setFieldValue('cdekDeliveryType', null);
            setShowWidget(false)
        }
    }, [delivery, cdekLoadStatus])

    useEffect(() => {
        if (cityCode && widget?.DATA?.regions?.collection && widget?.DATA?.regions?.collection[cityCode]) {
            const [ region, country ] = widget?.DATA?.regions?.collection[cityCode].split(', ')
            setFieldValue('region', region);
            setFieldValue('country', country);
        } else {
            setFieldValue('region', '');
            setFieldValue('country', 'Российская Федерация');
        }
    }, [cityCode, widget?.DATA])

    useEffect( () => {
        if (widget === null) {
            console.log('widget has not been initialized')
        }
        if ( widget !== null && items?.length >= 0 ) {
            widget.resetParcels();
            items.forEach(item => {
                widget.addParcel(item);
            })
        }
    }, [ items, widget ] )

    useEffect(() => {
        if (delivery !== 'cdek') {
            setFieldValue('cdekDeliveryType', null);
        }
    }, [delivery])

    const onClickShowWidget = (e) => {
        setFieldValue('delivery', 'cdek');
        setShowWidget(true);
    }

    const Description = () => <div className={el('description')}>
        <div className={el('description-text')}>
            <Text >Доставка осуществляется компанией&nbsp;</Text>
            <a href={ 'http://www.cdek.ru' } target={ '_blank' }>СДЭК</a>
        </div>
        { !showWidget && <div className={el('description-button')} onClick={onClickShowWidget}>
            <Text>{values.cdekDeliveryType ? 'Изменить выбор' :  'Выберите на карте'}</Text>
        </div> }
    </div>

    return <>
        <div className={ el( 'radio-option', { 'delivery-region' : true, selected}) }>
            <FormikRadioField
                name={'delivery'}
                text={ 'Доставка по России' }
                value={'cdek'}
                html={Description}
            />
            { (delivery === 'cdek' ) &&
                <>
                    { meta.error && <div className='form-error'>{meta.error}</div>}
                    {/*{ values.cdekDeliveryType === 'courier' &&*/}
                    {/*    <div className={el('cdek-text')}>*/}
                    {/*        <Text s16 tag={ 'div' }>*/}
                    {/*            Вы выбрали доставку курьером в городе {values.city}.*/}
                    {/*        </Text>*/}
                    {/*        <Text>*/}
                    {/*            {values.country}*/}
                    {/*            {values.address}*/}
                    {/*        </Text>*/}
                    {/*    </div>}*/}
                    {/*{ values.cdekDeliveryType === 'pvz' &&*/}
                    {/*<div className={el('cdek-text')}>*/}
                    {/*    <Text s16 tag={ 'div' }>*/}
                    {/*        Вы выбрали доставку до пункта выдачи в городе {values.city} по адресу {values.address}.*/}
                    {/*    </Text>*/}
                    {/*</div>}*/}
                </> }
        </div>
    </>
})

export default CDEK;
